import {
  List,
  Datagrid,
  TextField,
  NumberField,
  DateField,
  BooleanField,
  Edit,
  SimpleForm,
  TextInput,
  NumberInput,
  DateTimeInput,
  SelectInput,
  BooleanInput,
  ReferenceInput,
  ReferenceField,
  Create,
  required,
} from "react-admin";

const leagueFixtureFilters = [
  <ReferenceInput key="season_id" source="season_id" reference="admin/seasons" alwaysOn>
    <SelectInput label="Stagione" optionText="label" emptyText="Tutte le stagioni" />
  </ReferenceInput>,
];

export const LeagueFixtureList = () => (
  <List filters={leagueFixtureFilters} perPage={200} pagination={false}>
    <Datagrid rowClick="edit">
      <ReferenceField source="season_id" reference="admin/seasons" label="Stagione">
        <TextField source="label" />
      </ReferenceField>
      <NumberField source="matchday" label="Giornata" />
      <DateField source="starts_at" showTime label="Data" />
      <TextField source="home_team" label="Casa" />
      <TextField source="away_team" label="Trasferta" />
      <TextField source="status" label="Stato" />
      <NumberField source="home_goals" label="Gol Casa" />
      <NumberField source="away_goals" label="Gol Trasferta" />
      <TextField source="field_name" label="Campo" />
      <BooleanField source="is_bye" label="Riposo" />
    </Datagrid>
  </List>
);

export const LeagueFixtureEdit = () => (
  <Edit>
    <SimpleForm>
      <ReferenceInput source="season_id" reference="admin/seasons" label="Stagione">
        <SelectInput optionText="label" disabled />
      </ReferenceInput>
      <TextInput source="competition" disabled />
      <NumberInput source="matchday" />

      <DateTimeInput source="starts_at" />

      <TextInput source="home_team" fullWidth />
      <TextInput source="away_team" fullWidth />

      <TextInput source="field_name" fullWidth />
      <TextInput source="notes" fullWidth multiline />

      <SelectInput
        source="status"
        choices={[
          { id: "scheduled", name: "In programma" },
          { id: "played", name: "Giocata" },
          { id: "canceled", name: "Annullata" },
        ]}
      />

      <NumberInput source="home_goals" />
      <NumberInput source="away_goals" />

      <BooleanInput source="is_bye" label="Riposo" />
    </SimpleForm>
  </Edit>
);

export const LeagueFixtureCreate = () => (
  <Create>
    <SimpleForm>
      <ReferenceInput source="season_id" reference="admin/seasons" label="Stagione" sort={{ field: "label", order: "DESC" }}>
        <SelectInput optionText="label" validate={[required()]} />
      </ReferenceInput>
      <TextInput source="competition" defaultValue="league" />
      <NumberInput source="matchday" />

      <DateTimeInput source="starts_at" />

      <TextInput source="home_team" fullWidth />
      <TextInput source="away_team" fullWidth />

      <TextInput source="field_name" fullWidth />
      <TextInput source="notes" fullWidth multiline />

      <SelectInput
        source="status"
        defaultValue="scheduled"
        choices={[
          { id: "scheduled", name: "In programma" },
          { id: "played", name: "Giocata" },
          { id: "canceled", name: "Annullata" },
        ]}
      />

      <NumberInput source="home_goals" defaultValue={0} />
      <NumberInput source="away_goals" defaultValue={0} />

      <BooleanInput source="is_bye" defaultValue={false} label="Riposo" />
    </SimpleForm>
  </Create>
);
